import { z } from "zod";
import { FiltersTypes } from "@common/types/filters/general";
import {
    RuleActionType,
    RuleReviewStatus,
    RuleSourceFilter,
    RuleStatus,
} from "@common/types/transactionRule";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

export type RulesPageFiltersCache = Pick<
    FiltersTypes,
    | "entityIds"
    | "ruleStatuses"
    | "ruleSources"
    | "ruleActionTypes"
    | "ruleReviewStatuses"
    | "ruleReviewerIds"
    | "ruleReviewerMode"
    | "counterpartiesIds"
    | "classes"
    | "coaAccounts"
    | "accrualCoaAccounts"
>;

const rulesPageFiltersCacheSchema = z.object({
    entityIds: z.array(z.number()).optional(),
    ruleStatuses: z.array(z.nativeEnum(RuleStatus)).optional(),
    ruleSources: z.array(z.nativeEnum(RuleSourceFilter)).optional(),
    ruleActionTypes: z.array(z.nativeEnum(RuleActionType)).optional(),
    ruleReviewStatuses: z.array(z.nativeEnum(RuleReviewStatus)).optional(),
    ruleReviewerIds: z.array(z.number()).optional(),
    ruleReviewerMode: z.enum(["all", "any", "none"]).optional(),
    counterpartiesIds: z.array(z.string()).optional(),
    classes: z.array(z.string()).optional(),
    coaAccounts: z.array(z.string()).optional(),
    accrualCoaAccounts: z.array(z.string()).optional(),
});

export function useRulesPageFiltersCache(): [
    RulesPageFiltersCache | undefined,
    (value: RulesPageFiltersCache | undefined) => void,
] {
    return useWorkspaceUserCache<RulesPageFiltersCache>(
        WORKSPACE_USER_CACHE_KEYS.RULES_PAGE_FILTERS_CACHE_KEY,
        rulesPageFiltersCacheSchema,
    );
}
